export default "__VITE_ASSET__3b3c7e59__"